export class PagingParametersModel {

  constructor(public Sort?: string, public Order?: string, public Page?: number, public Size?: number) {
  }
}
